import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { auth0Config } from "../config/auth0";

interface Auth0ProviderWrapperProps {
  children: React.ReactNode;
}

const Auth0ProviderWrapper: React.FC<Auth0ProviderWrapperProps> = ({
  children,
}) => {
  // Use the configured redirect URI as-is (don't force HTTPS in development)
  const redirectUri =
    auth0Config.redirectUri || `${window.location.origin}/callback`;

  console.log("🔧 [AUTH0_PROVIDER] Configuration:", {
    domain: auth0Config.domain,
    clientId: auth0Config.clientId ? "present" : "missing",
    audience: auth0Config.audience,
    scope: auth0Config.scope,
    redirectUri: redirectUri,
  });

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
      }}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      cacheLocation="localstorage"
      // Handle successful authentication redirect
      onRedirectCallback={(appState, user) => {
        console.log("✅ [AUTH0_PROVIDER] Redirect callback successful:", {
          appState,
          user: user?.sub,
        });

        // Check if we have Auth0 tokens after successful authentication
        const auth0Keys = Object.keys(localStorage).filter((key) =>
          key.includes("@@auth0spajs@@")
        );
        console.log(
          "🔧 [AUTH0_PROVIDER] Auth0 tokens found:",
          auth0Keys.length
        );
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWrapper;
